// material-ui
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export default function Footer() {
  return (
    <Stack
      direction="row"
      sx={{
        alignItems: "center",
        justifyContent: "center",
        p: "24px 16px 0px",
        mt: "auto",
      }}
    >
      <Typography variant="caption">
        &copy; 2025 TobyLabs. All rights reserved.
      </Typography>
    </Stack>
  );
}
